import styled from 'styled-components';

export const ScreenWrapper = styled.div`
	width: 100%;
	height: 100%;
	min-height: 100vh;
	text-align: center;
`;

export const Hint = styled.div`
	color: grey;
`;

export const TileWrapper = styled.div`
	width: 100%;
	@media (max-width: 800px) { 
		width: calc(100% - 20px);
	}
	${props => (!props.collapse ? `
		height: 300px;
	` : `
		display: flex;
		align-items: center;
	`)}
    border: 1px solid lightgrey;
    margin: 10px;
    box-shadow: 1px 1px 2px lightgrey;
	position: relative;
	background-color: ${props => (props.theme === 'dark' ? '#222222' : 'white')};
	transition: background-color 1s;
	
	${props => (props.animate && props.loaded ? `
		transform: TranslateY(0);
		transition: transform 1s;
		&:hover {
			transform: TranslateY(-5px);
			cursor: pointer;
		}
	` : '')}

	& .aggregate-loader {
		margin-top: 35px;
		font-size: 2em;
		color: pink;
	}
`;